import ReportCategoryCard from 'components/cards/ReportCategoryCard'
import SectionHeader from 'components/common/SectionHeader'
import { ReportCategory } from 'interface/ReportCategory'
import React from 'react'
import styles from 'styles/layout/ReportCategoriesItemSection.module.sass'

/**
 * Props for the `ReportCategoriesItemSectionProps` component.
 * @typedef {Object} ReportCategoriesItemSectionProps
 * @property {ReportCategory[]} categories - Array of report categories to display.
 */
interface ReportCategoriesItemSectionProps {
    categories: ReportCategory[]
}

/**
 * ReportCategoriesItemSection component displays a section of report categories.
 *
 * @component
 * @param {ReportCategoriesItemSectionProps} props - Props containing an array of report categories to display.
 *
 * @example
 * // Example usage:
 * import ReportCategoriesItemSection from './ReportCategoriesItemSection';
 *
 * const categories = [
 *   { id: 'f25fdb13-69fd-45f9-916b-af150859536d', title: 'Finance', meta: 'Latest financial reports' },
 *   { id: 'd4e5f6b7-8c9d-0e1f-2g3h-4i5j6k7l8m9n', title: 'Technology Trends', meta: 'Latest technology trends reports' }
 * ];
 *
 * <ReportCategoriesItemSection categories={categories} />;
 *
 * @returns {JSX.Element} The rendered ReportCategoriesItemSection component.
 */
const ReportCategoriesItemSection: React.FC<ReportCategoriesItemSectionProps> = ({ categories }) => {
    return (
        <section className={styles['report-categories-item-section']} id={'report-categories-item-section'}>
            <SectionHeader
                title="FIND REPORTS BY CATEGORY"
                subtitle="Explore Our Report Categories"
            />
            <div className={styles['categories-wrapper']}>
                {categories && categories.map((category) => (
                    <ReportCategoryCard
                        key={category.id}
                        id={category.id}
                        title={category.title}
                        description={category.shortDescription}
                        meta={category.meta}
                    />
                ))}
            </div>
        </section>
    )
}

export default ReportCategoriesItemSection